module.exports = __webpack_public_path__ + "img/car_ricon.68d14890.png";